import { useContext, useState, useRef } from 'react';
import styles from './CadastroProdutos.module.css';
import SideBarGestaoAdmin from '../components/SideBarGestaoAdmin';
import MobileMenu from '../../../shared/components/MobileMenu';
import HeaderAdmin from '../components/HeaderAdmin';
import ProdutoTabela from '../components/ProdutoTabela';
import { ProdutosContext } from '../../../shared/contexts/ProdutosContext';
import CadastrarProdutoPopUp from '../../../shared/components/CadastrarProdutoPopUp';
import { fetchWithAuth, getToken } from '../../../shared/utils/auth';

function CadastroItens() {
  const { produtos, carregarProdutos } = useContext(ProdutosContext);
  const [mostrarCadastro, setMostrarCadastro] = useState(false);
  const [mostrarImportarPdf, setMostrarImportarPdf] = useState(false);
  const [arquivoPdf, setArquivoPdf] = useState(null);
  const [carregandoPdf, setCarregandoPdf] = useState(false);
  const fileInputRef = useRef(null);

  const handleArquivoPdf = (e) => {
    const arquivo = e.target.files[0];
    if (arquivo && arquivo.type === 'application/pdf') {
      setArquivoPdf(arquivo);
    } else {
      alert('Por favor, selecione um arquivo PDF válido!');
    }
  };

  const processarPdfCardapio = async () => {
    if (!arquivoPdf) {
      alert('Por favor, selecione um arquivo PDF primeiro!');
      return;
    }

    try {
      setCarregandoPdf(true);
      const API_URL = process.env.REACT_APP_API_URL;
      const estabelecimento_id = localStorage.getItem("estabelecimento_id");

      if (!estabelecimento_id) {
        alert("Erro: Estabelecimento não identificado. Por favor, faça login novamente.");
        return;
      }

      const formData = new FormData();
      formData.append('pdf', arquivoPdf);

      const token = getToken();

      const response = await fetch(`${API_URL}/extract-cardapio`, {
        method: 'POST',
        // Não definir Content-Type manualmente: o navegador precisa gerar o
        // boundary do multipart/form-data sozinho.
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        body: formData
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Erro desconhecido' }));
        console.error('Erro na resposta do servidor:', errorData);
        throw new Error(errorData.error || errorData.details || 'Erro ao processar PDF');
      }

      const data = await response.json();
      const produtosExtraidos = data.produtos;

      if (!produtosExtraidos || produtosExtraidos.length === 0) {
        alert('Nenhum produto foi encontrado no PDF');
        return;
      }

      let sucessos = 0;
      let erros = 0;

      for (const produto of produtosExtraidos) {
        try {
          const responseCadastro = await fetchWithAuth(`${API_URL}/cadastroprodutos`, {
            method: "POST",
            body: JSON.stringify({
              nome_item: produto.nome || produto.name,
              descricao: produto.descricao || produto.description || '',
              preco: produto.preco || produto.price || 0,
              id_categoria: produto.id_categoria || null,
              imagem: '',
              disponivel: true,
              // Cardápio importado não traz contagem de estoque — deixa
              // ilimitado (null) em vez de 0 (que apareceria como "em falta").
              quantidade: null,
              id_estabelecimento: estabelecimento_id
            })
          });

          if (responseCadastro && responseCadastro.ok) {
            sucessos++;
          } else {
            erros++;
          }
        } catch (error) {
          console.error('Erro ao cadastrar produto:', error);
          erros++;
        }
      }

      alert(`Processamento concluído!\nProdutos cadastrados: ${sucessos}\nErros: ${erros}`);

      if (carregarProdutos) {
        carregarProdutos();
      }

      setArquivoPdf(null);
      setMostrarImportarPdf(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } catch (error) {
      console.error('Erro ao processar PDF:', error);
      alert(`Erro ao processar o arquivo PDF: ${error.message || 'tente novamente.'}`);
    } finally {
      setCarregandoPdf(false);
    }
  };

  const fecharModalPdf = () => {
    setMostrarImportarPdf(false);
    setArquivoPdf(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <div className={styles.secaoPrincipal}>
      {/* Menu Mobile */}
      <MobileMenu />

      {/* Sidebar fixa à esquerda */}
      <SideBarGestaoAdmin />

      {/* Container principal do dashboard */}
      <div className={styles.containerDashboard}>
        <HeaderAdmin />

        <div className={styles.contentWrapper}>
          <div className={styles.contentDashboard}>
            <div className={styles.mainColumn}>
              {produtos && produtos.length > 0 ? (
                <ProdutoTabela produtosFiltradosExternos={produtos} />
              ) : (
                <div className={styles.emptyState}>
                  <div className={styles.emptyIcon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className={styles.iconSvg}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                  </div>
                  <h2 className={styles.emptyTitle}>Nenhum produto cadastrado</h2>
                  <p className={styles.emptyText}>
                    Comece cadastrando seu primeiro produto para exibir no cardápio
                  </p>
                  <button
                    className={styles.btnCadastrarEmpty}
                    onClick={() => setMostrarCadastro(true)}
                  >
                    Cadastrar Primeiro Produto
                  </button>
                  <button
                    className={styles.btnImportarPdfEmpty}
                    onClick={() => setMostrarImportarPdf(true)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className={styles.btnIcon}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                      />
                    </svg>
                    Importar Cardápio via PDF
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Botões Flutuantes */}
        <div className={styles.fabContainer}>
          <button
            className={styles.fabButtonSecondary}
            onClick={() => setMostrarImportarPdf(true)}
            title="Importar Cardápio via PDF"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className={styles.fabIcon}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
              />
            </svg>
          </button>
          <button
            className={styles.fabButton}
            onClick={() => setMostrarCadastro(true)}
            title="Adicionar Produto"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className={styles.fabIcon}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v16m8-8H4"
              />
            </svg>
          </button>
        </div>

        {/* Modal de Cadastro */}
        {mostrarCadastro && (
          <div className={styles.modalOverlay} onClick={() => setMostrarCadastro(false)}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <button className={styles.modalClose} onClick={() => setMostrarCadastro(false)}>
                ×
              </button>
              <CadastrarProdutoPopUp onClose={() => setMostrarCadastro(false)} />
            </div>
          </div>
        )}

        {/* Modal de Importar PDF */}
        {mostrarImportarPdf && (
          <div className={styles.modalOverlay} onClick={fecharModalPdf}>
            <div className={styles.modalContentPdf} onClick={(e) => e.stopPropagation()}>
              <button className={styles.modalClose} onClick={fecharModalPdf}>
                ×
              </button>
              <div className={styles.pdfModalInner}>
                <h2 className={styles.pdfModalTitle}>Importar Cardápio via PDF</h2>
                <p className={styles.pdfModalDescription}>
                  Faça upload do cardápio em PDF para extrair e cadastrar todos os produtos automaticamente
                </p>
                <div className={styles.pdfInputGroup}>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="application/pdf"
                    onChange={handleArquivoPdf}
                    className={styles.pdfFileInput}
                    disabled={carregandoPdf}
                  />
                  {arquivoPdf && (
                    <span className={styles.pdfFileName}>
                      Arquivo selecionado: {arquivoPdf.name}
                    </span>
                  )}
                </div>
                <button
                  type="button"
                  onClick={processarPdfCardapio}
                  className={styles.btnProcessarPdf}
                  disabled={!arquivoPdf || carregandoPdf}
                >
                  {carregandoPdf ? 'Processando PDF...' : 'Processar e Cadastrar Produtos'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CadastroItens;
